import { getContext, setContext } from "svelte";

type LayoutContext = {
    collapse: (id: string, value?: boolean) => void;
};

const LAYOUT_CONTEXT_KEY = "sublayout";

export function getSubLayout() {
    return getContext<LayoutContext>(LAYOUT_CONTEXT_KEY);
}

export function setSubLayout(context: LayoutContext) {
    setContext(LAYOUT_CONTEXT_KEY, context);
}